export const relativeToLabel = (
    dateRange,
    withRounded = true,
) => {
    const value =
        typeof dateRange.value === 'string'
            ? parseInt(dateRange.value, 10)
            : dateRange.value;

    let unitCountLabel = '';
    let suffix = '';
    if (value === 0) {
        if (dateRange.unit === 'day') {
            unitCountLabel = 'Today';
        } else {
            unitCountLabel = `This ${dateRange.unit}`;
        }
    } else if (value === 1) {
        if (dateRange.unit === 'day') {
            unitCountLabel = 'Yesterday';
        } else {
            unitCountLabel = `${value} ${dateRange.unit}`;
            suffix = 'ago';
        }
    } else if (value > 1) {
        unitCountLabel = `${value} ${dateRange.unit}s`;
        suffix = 'ago';
    }
    if (dateRange.round && withRounded) {
        suffix = `${suffix} (rounded)`;
    }
    if (suffix) {
        return `${unitCountLabel} ${suffix}`;
    }
    return unitCountLabel;
};